enum GuardTypes {
     ACCESS_ALL = 'access_all',
     ACCESS_LOGIN = 'access_login',
     ACCESS_NO_LOGIN = 'access_no_login',
}

export default GuardTypes;